import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChangePasswordComponent } from './change-password.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { ProgressButtonModule } from '@fleet/ui/progress-button/progress-button.module';
import { MatIconModule } from '@angular/material/icon';

import { AlertsFromIssuesModule } from '@fleet/issue';
import { FuseAlertModule } from '@fleet/fuse';

@NgModule({
  declarations: [ChangePasswordComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    ProgressButtonModule,
    MatIconModule,
    FuseAlertModule,
    AlertsFromIssuesModule,
  ],
  exports: [ChangePasswordComponent],
})
export class ChangePasswordModule {}
